import { useTranslation } from 'react-i18next'
import { VenueUnavailableStyles } from './styles'

// Exibido quando a venue está desativada (Venues.disabled): não permite entrar na fila
function VenueUnavailable() {
	const { t } = useTranslation()

	return (
		<VenueUnavailableStyles>
			<h1>{t('venueUnavailable.title')}</h1>
			<p>{t('venueUnavailable.message')}</p>
		</VenueUnavailableStyles>
	)
}

export default VenueUnavailable
